import { Lightbulb } from "lucide-react";
import { waLink, WA_MESSAGES, trackWhatsApp } from "@/lib/whatsapp";
import Reveal from "./Reveal";
import WhatsAppIcon from "./WhatsAppIcon";

export default function SuggestPlace() {
  return (
    <section id="sugerir" className="mx-auto max-w-7xl px-5 pb-24 sm:px-8 sm:pb-32" data-testid="suggest-section">
      <Reveal>
        <div className="rounded-3xl border border-white/10 bg-[#161B22] p-10 sm:p-16">
          <p className="flex items-center gap-2 font-mono text-xs font-semibold uppercase tracking-[0.25em] text-amber-400">
            <Lightbulb className="h-4 w-4" />
            Sugestão
          </p>
          <h2 className="mt-5 max-w-2xl font-display text-3xl font-extrabold leading-tight tracking-tight text-stone-50 sm:text-4xl lg:text-5xl">
            Não encontrou o lugar{" "}
            <em className="font-accent font-medium italic text-amber-400">que procura?</em>
          </h2>
          <p className="mt-6 max-w-xl text-base leading-relaxed text-stone-300 sm:text-lg">
            Tem algum lugar do Rio que você gostaria de conhecer e não está no catálogo?
            Me conte qual é. Vamos avaliar juntos a possibilidade de incluir o local em
            um roteiro personalizado, de acordo com tempo, deslocamento e disponibilidade.
          </p>
          <p className="mt-5 font-accent text-xl font-medium italic text-amber-400">
            Você sugere. A gente avalia.
          </p>
          <a
            href={waLink(WA_MESSAGES.sugestao)}
            onClick={() => trackWhatsApp("sugerir_lugar", "sugestao")}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="suggest-cta"
            className="mt-9 inline-flex items-center gap-3 rounded-full bg-[#25D366] px-8 py-4 text-sm font-bold uppercase tracking-wider text-white shadow-[0_0_40px_rgba(37,211,102,0.3)] transition-[background-color,transform] duration-300 hover:scale-[1.03] hover:bg-[#20BD5A]"
          >
            <WhatsAppIcon className="h-5 w-5" />
            Sugerir um lugar
          </a>
        </div>
      </Reveal>
    </section>
  );
}
